import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAirline, updateAirline, deleteAirline } from "./api";
import { AirlinesKeys } from "./queries";
import type { Airline, CreateAirlinePayload, UpdateAirlinePayload } from "./types";

export function useCreateAirlineMutation() {
  const qc = useQueryClient();
  return useMutation<Airline, Error, CreateAirlinePayload>({
    mutationFn: (payload) => createAirline(payload),
    onSuccess(created) {
      qc.setQueryData<Airline>(AirlinesKeys.detail(created.id), created);
      qc.invalidateQueries({ queryKey: AirlinesKeys.all });
    },
  });
}

export function useUpdateAirlineMutation(id: number | string) {
  const qc = useQueryClient();
  return useMutation<Airline, Error, UpdateAirlinePayload>({
    mutationFn: (payload) => updateAirline(id, payload),
    onSuccess(updated) {
      qc.setQueryData<Airline>(AirlinesKeys.detail(id), updated);
      qc.invalidateQueries({ queryKey: AirlinesKeys.all });
    },
  });
}

export function useDeleteAirlineMutation() {
  const qc = useQueryClient();
  return useMutation<{ message: string } | void, Error, number | string>({
    mutationFn: (id) => deleteAirline(id),
    onSuccess(_res, id) {
      qc.removeQueries({ queryKey: AirlinesKeys.detail(id) });
      qc.invalidateQueries({ queryKey: AirlinesKeys.all });
    },
  });
}
